<div>
    <button mat-stroked-button color="primary" (click)="download()">Download</button>
    <button mat-stroked-button (click)="like()">Like</button>
    @if (user.id === asset.author.id) {
        <button mat-button color="warn" (click)="delete()">Delete</button>
    }
</div>
